function setBounds(_self: any, markers: any) {
    if (typeof window === 'undefined' || typeof google === 'undefined') return;
    if (!_self.$refs.googleMap?.map || !markers.length) return;

    let bounds = null
    if (!_self.bounds) {
        bounds = new google.maps.LatLngBounds();
        _self.bounds = bounds
    } else {
        bounds = _self.bounds
    }

    markers.forEach((marker: { coordinates: any; }) => {
        bounds.extend(marker.coordinates);
    });

    _self.googleMap.map.fitBounds(bounds, {
        maxZoom: 15,
        duration: 1000
    });
}

export function getGoogleInitialVariables() {
    return {
        bounds: null,
        googleMap: null,
        defaultCenter: { lat: 40.417372, lng: -3.703284 },
        setBounds
    }

}